import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, inject, computed } from 'vue';
import request from '@/utils/request';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  emits: ['search'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const route = useRoute();
    // 获取searchType image ppt video...
    const searchType = inject('searchType');
    const searchKeyword = ref('');
    const handleSearch = async () => {
      const moduleType = filterCategoryInRoute();
      const searchFunc = async type => {
        if (searchKeyword.value.trim()) {
          return await request({
            url: `/api/resources/${type}?title=${searchKeyword.value.trim()}&module=${moduleType}`,
            method: 'get'
          });
        } else {
          return await request({
            url: `/api/resources/${type}?module=${moduleType}`,
            method: 'get'
          });
        }
      };
      if (searchKeyword.value.trim()) {
        if (searchType === 'image' || searchType === 'ppt' || searchType === 'video') {
          const res = await searchFunc(searchType);
          // console.log('res', res);
          const searchResult = res.data.result;
          emit('search', searchResult);
        }
      } else {
        const res = await searchFunc(searchType);
        // console.log('res', res);
        const searchResult = res.data.result;
        emit('search', searchResult);
      }
    };
    const placeholderText = computed(() => {
      if (searchType === 'image') {
        return '请输入图片名称';
      } else if (searchType === 'ppt') {
        return '请输入PPT名称';
      } else if (searchType === 'video') {
        return '请输入视频名称';
      }
      return '请输入搜索内容';
    });
    // 根据路由返回搜索的分类字符串
    const filterCategoryInRoute = () => {
      if (route.path.includes('courses')) {
        return 'course';
      } else if (route.path.includes('instructions')) {
        return 'instruction';
      }
    };
    return (_ctx, _cache) => {
      const _component_search = _resolveComponent("search");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(_component_el_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        placeholder: placeholderText.value,
        size: "large",
        clearable: "",
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        prefix: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "search-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_search)]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: handleSearch
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("搜索")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder"]);
    };
  }
});